import { EVENTS } from './events'

export const FACEBOOK_EVENTS = {
  [EVENTS.SIGN_UP_SUCCESS]: 'CompleteRegistration',
  [EVENTS.SIGN_IN_SUCCESS]: 'Lead',
  [EVENTS.CHECKOUT_SUCCESS]: 'Purchase',
  [EVENTS.START_TRIAL]: 'StartTrial',
} as const
